import {
  CO_GET_HEAVEYCOLLI_LISTING,
  CO_GET_HEAVEYCOLLI_LISTING_SUCCESS,
  CO_GET_HEAVEYCOLLI_LISTING_FAILED,
  } from "./actionTypes"
  
  export const coHeaveyColliListing = () => {
    return {
      type: CO_GET_HEAVEYCOLLI_LISTING,
    }
  }
  
  export const coHeaveyColliListingSuccess = heaveyColli => {
    return {
      type: CO_GET_HEAVEYCOLLI_LISTING_SUCCESS,
      payload: heaveyColli,
    }
  }
  
  export const coHeaveyColliListingFail = error => {
    return {
      type: CO_GET_HEAVEYCOLLI_LISTING_FAILED,
      payload: error,
    }
  }
  